import { render, staticRenderFns } from "./stamps.vue?vue&type=template&id=6692e9e1&scoped=true&"
import script from "./stamps.vue?vue&type=script&lang=js&"
export * from "./stamps.vue?vue&type=script&lang=js&"
import style0 from "./stamps.vue?vue&type=style&index=0&id=6692e9e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6692e9e1",
  null
  
)

export default component.exports